<section class="customMenu text-center">
  <h3>
    About page
  </h3>
  <br/>
    Designed and developed by <a href="https://galliakis.com">Michael Galliakis</a> for the University of Piraeus
    Computational Biomedicine Laboratory.
  <hr/>
  <h4>Version {{VERSION}}</h4>
</section>
